import React, { forwardRef } from 'react';
import { useObserveRef, useLazyConst } from '@chkp/mwc-common';

// react-window doesn't allow passing props to the outer/inner elements: https://github.com/bvaughn/react-window/issues/242
// Solution - creating the type internally & passing props via observable ref
const useInnerElementType = ({ totalWidthObservable }) => {
	const Type = useLazyConst(() =>
		forwardRef((innerElementProps, ref) => {
			useObserveRef(totalWidthObservable, (totalWidth) => {
				// eslint-disable-next-line no-param-reassign
				ref.current.style.minWidth = `${totalWidth || 0}px`;
			});

			return (
				<div
					{...innerElementProps}
					ref={ref}
					style={{
						...innerElementProps.style,

						width: '100%',
						// Virtualized list must always have the width of all columns -
						// in order for the horizontal scrollbar to show even if there's no data
						minWidth: totalWidthObservable.current || 0,

						overflow: 'hidden',
					}}
					data-tag={'list-wrapper'}
				/>
			);
		}),
	);

	return Type;
};

export { useInnerElementType };
